import { ChangePasswordRequestPayload } from "@/data/payload/user/change-password-request-payload";
import { UserRepository } from "@/domain/repository/user-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class ChangePasswordWhenLoginUsecase {
  //MARK:- init
  constructor(private readonly userRepo: UserRepository) {}

  //MARK: - execute
  async execute(sn: string, newSn: string): Promise<SATResult<void, SATError>> {
    const payload: ChangePasswordRequestPayload = {
      sn: sn,
      newSn: newSn,
    };

    console.log("[ChangePasswordWhenLoginUsecase] :: execute :: 비밀번호 변경 요청 시작");
    const result = await this.userRepo.changePasswordWhenLogin(payload);
    if (result.isFailure) {
      console.log(
        "[ChangePasswordWhenLoginUsecase] :: execute :: 비밀번호 변경 실패",
        result.error
      );
      return SATResult.failure(result.error);
    }

    console.log("[ChangePasswordWhenLoginUsecase] :: execute :: 비밀번호 변경 성공");
    return SATResult.success(undefined);
  }
}
